import appLoaderLang from './loader/langs/appLoaderLang';
import appNotificationLang from './notification/langs/appNotificationLang';

const AppFeatureLangs = [appNotificationLang, appLoaderLang];

export default AppFeatureLangs;
